import React from "react";
import { API } from "../../backend";

const CardImage = ({product}) => {

    const imgUrl = product ? `${product.downloadURL}` : '';

    return(
        <img
            src={imgUrl}
            className="mb-3 rounded card-image"
            alt=""
        />
    );
}

export default CardImage;
